import { useState } from 'react'
import { trackInternalEvent } from '@rio/tracking'
import { Icon24 } from 'builder/components/Icon'
import { useSaveCoursesMutation } from '../hooks/useSaveCourseMutation'
import HeartIcon from '../assets/HeartIcon.svg'
import { FavoriteButton } from './styles'

export const SaveCourseAction = (props: { courseId: string; isAlreadySaved?: boolean }) => {
  const [isSaved, setIsSaved] = useState(props.isAlreadySaved || false)
  const { mutate } = useSaveCoursesMutation({
    onError: () => setIsSaved(false),
  })

  const handleClick = async (e: React.MouseEvent) => {
    e.stopPropagation()
    e.preventDefault()
    trackInternalEvent('click_save_course', { courseId: props.courseId })
    const next = !isSaved
    setIsSaved(next)
    mutate({ CMSGID: props.courseId, isSaved: next })
  }

  return (
    <FavoriteButton
      onClick={handleClick}
      data-testid={isSaved ? 'unsave-course-button' : 'save-course-button'}
    >
      {isSaved ? <Icon24.HeartFullFilled /> : <img src={HeartIcon} alt="Save course" />}
    </FavoriteButton>
  )
}
